'use client'

import cx from 'classnames'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'

import RequiredLabel from '@/components/Form/Atoms/RequiredLabel'
import { SurveyQuestionType } from '@/types/surveyQuestion'

export type Props = {
  surveyAnswersKeyName: string
  surveyQuestion: SurveyQuestionType
  index: number | null
}

export default function SurveyFormRadio({ surveyAnswersKeyName, surveyQuestion, index }: Props) {
  const { watch, register } = useFormContext()

  const watchValue = watch(surveyAnswersKeyName)

  return (
    <div className={cx('c-surveyForm-surveyForm__questions')}>
      <div className="c-inputBase__label u-mb14">
        <span>
          {index !== null && <span>{index + 1}. </span>}
          {surveyQuestion.name}
          {surveyQuestion.answerRequired && <RequiredLabel />}
        </span>
      </div>

      <div className={'c-surveyForm-surveyForm__questions-radio'}>
        {surveyQuestion.surveyOptions.map((surveyOption) => {
          return (
            <Fragment key={surveyOption.surveyOptionId}>
              <label
                htmlFor={surveyOption.surveyOptionId}
                className={cx('c-surveyForm-surveyForm__questions-radio-label')}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  opacity="1"
                >
                  <circle cx="7" cy="7" r="6.5" stroke="#060725" />
                  {(watchValue[surveyQuestion.surveyQuestionId] || []).includes(surveyOption.surveyOptionId) ? (
                    <circle cx="7" cy="7" r="3" fill="#060725" />
                  ) : (
                    <></>
                  )}
                </svg>

                <input
                  id={surveyOption.surveyOptionId}
                  type="radio"
                  value={surveyOption.surveyOptionId}
                  {...register(`${surveyAnswersKeyName}.${surveyQuestion.surveyQuestionId}`)}
                />

                <p>{surveyOption.name}</p>
              </label>
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}
